import moment from 'moment';

const convertTimestampForEstimate = (timestamp) => {
  let date = moment(timestamp);
  return date.format('MM/DD/YYYY H:mm');
};

const convertYearMonthDay = (timestamp) => {
  let date = moment(timestamp, 'MM/DD/YYYY HH:mm');
  return date.format('YYYY-MM-DD HH:mm');
};

const getDateFromUTC = (timestamp) => {
  let date = moment(timestamp);
  return date.format('ddd. MMM. D, YYYY');
};

const getTimeFromUTC = (timestamp) => {
  let time = moment(timestamp);

  if (time.get('minute') === '00') return time.format('h a');
  return time.format('h:mm a');
};

const getFormattedDateFromString = (inputDate) => {
  let date = moment(inputDate, 'MM/DD/YYYY');
  return date.format('ddd. MMM. D, YYYY');
};

const getFormattedTimeFromString = (inputTime) => {
  let time = moment(inputTime, 'H:mm');
  if (time.get('minute') === '00') return time.format('h a');
  return time.format('h:mm a');
};

const militaryToStandardTime = (inputTime) => {
  let time = moment(inputTime, 'H:mm');
  return time.format('h:mm a');
};

const militaryToShortStandardTime = (inputTime) => {
  let time = moment(inputTime, 'H:mm');
  return time.format('h a');
};

const standardToMilitaryTime = (inputTime) => {
  let time = moment(inputTime, 'h:mm A');
  return time.format('H:mm');
};

export {
  convertTimestampForEstimate,
  convertYearMonthDay,
  getDateFromUTC,
  getTimeFromUTC,
  getFormattedDateFromString,
  getFormattedTimeFromString,
  militaryToStandardTime,
  militaryToShortStandardTime,
  standardToMilitaryTime
};
